/**
 * Médecine générale — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: MED, MEDG, INFE
 * Catalogue acts (NGAP Maroc): 338
 */
import { defineSpecialty } from "../types";

export const medecine_generale = defineSpecialty(
{
  "id": "medecine-generale",
  "label": "Médecine générale",
  "short": "Méd. générale",
  "scope": "Consultations, visites, soins courants",
  "aliases": [
    "MED",
    "MEDG",
    "INFE"
  ],
  "doctorSpecs": [
    "Médecine interne",
    "Médecine générale",
    "Pédiatrie"
  ],
  "featureFlag": "ux.v2.medecine-generale",
  "theme": {
    "primary": "oklch(0.72 0.17 145)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 2,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 3,
      "requires": []
    },
    {
      "id": "lab",
      "label": "Laboratoire",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 4,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "patients",
      "label": "Patients",
      "icon": "Users",
      "route": "/clinical/patients",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "vitals",
      "label": "Constantes",
      "icon": "HeartPulse",
      "component": "VitalSignsGrid",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    },
    {
      "id": "prescriptions",
      "label": "Ordonnances",
      "icon": "Pill",
      "component": "PrescriptionList",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Médecine générale",
    "subSpecialties": [
      "Consultation",
      "Visite",
      "Soins courants"
    ],
    "catalogueActs": 338
  },
  "terminology": {
    "icd10": [
      "A00",
      "B00",
      "E00",
      "I00",
      "J00",
      "R00"
    ],
    "loinc": [
      "29463-7",
      "718-7",
      "2339-0"
    ],
    "snomed": []
  },
  "deviceProfiles": [],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default medecine_generale;
